import React, { useMemo } from 'react';
import right from '../../scss/component/cellRight.css';

const CreateTableData = () => {
  const columns = useMemo(
    () => [
      {
        Header: 'SKU',
        accessor: 'key',
        disableGlobalFilter: false,
        width: 160
      },
      {
        Header: 'Title',
        accessor: 'prouctName',
        disableGlobalFilter: false,
        width: 160

      },
      {
        Header: 'Cogs',
        accessor: 'cogs',
        disableGlobalFilter: false,
        rightAlign: true,
        width: 160

      },
      {
        Header: 'Collection',
        accessor: 'productCollection',
        disableGlobalFilter: false,
        headerClassName: 'right',
        width: 160

      },
      {
        Header: 'Category',
        accessor: 'productCategory',
        disableGlobalFilter: false,
        width: 160

      },
      {
        Header: 'SubCategory',
        accessor: 'productSubCategory',
        disableGlobalFilter: false,
        width: 160

      },
    ],
    [],
  );

  const getRandomDate = (start, end) => new Date(start.getTime() + (Math.random() * (end.getTime()
    - start.getTime()))).toLocaleDateString();

  const data = [];
  const rows = () => {
    for (let i = 1; i < 36; i += 1) {
      data.push({
        id: i,
        first: ['Maria', 'Bobby  ', 'Alexander'][Math.floor((Math.random() * 3))],
        last: ['Morrison', 'Brown  ', 'Medinberg'][Math.floor((Math.random() * 3))],
        user: ['@dragon', '@hamster', '@cat'][Math.floor((Math.random() * 3))],
        age: Math.min(100, Math.round(Math.random() * 30) + 20),
        date: getRandomDate(new Date(2002, 3, 1), new Date(1954, 3, 1)),
        location: ['Melbourne', 'Tokio', 'Moscow', 'Rome'][Math.floor((Math.random() * 4))],
        work: ['Nova Soft', 'Dog Shop', 'Aspirity', 'Business Bro', 'Starlight'][Math.floor((Math.random() * 5))],
      });
    }
  };

  rows();
  const reactTableData = { tableHeaderData: columns };
  return reactTableData;
};

export default CreateTableData;
